<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-data-table
          dense
          multi-sort
          :headers="tableHeaders"
          :items="items"
          :options.sync="options"
          :server-items-length="totalItems"
          :loading="loading"
          class="elevation-1">
          <template v-slot:top>
            <v-toolbar flat color="white">
              <v-toolbar-title>APL-uri</v-toolbar-title>
              <v-btn icon @click="refresh">
                <v-icon>mdi-refresh</v-icon>
              </v-btn>
              <v-divider vertical class="mx-4" inset></v-divider>
              <v-text-field v-model="search" label="Cautare" class="mx-4" clearable hide-details></v-text-field>
              <v-spacer></v-spacer>
              <v-menu offset-y :close-on-content-click="false">
                <template v-slot:activator="{ on }">
                  <v-btn
                    color="primary"
                    dark
                    v-on="on"
                    icon>
                    <v-icon>mdi-cog</v-icon>
                  </v-btn>
                </template>
                <v-list dense flat>
                  <v-list-item-group v-model="selectedHeaders" multiple>
                    <v-list-item
                      v-for="head in headers"
                      :key="head.value"
                      :value="head.text">
                      <template v-slot:default="{ active }">
                        <v-list-item-content>
                          <v-list-item-title v-text="head.text"></v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-icon>
                          <v-icon small :color="active ? 'primary' : 'error'">{{ active ? 'mdi-check' : 'mdi-close' }}</v-icon>
                        </v-list-item-icon>
                      </template>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-menu>
            </v-toolbar>
          </template>
          <template v-slot:item.logo.url="{ item }">
            <v-img
              :src="getIcon(item.logo, 'logo')"
              lazy-src="data:image/png;base64,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"
              max-height="20"
              max-width="40"
              contain>
            </v-img>
          </template>
          <template v-slot:item.icon.url="{ item }">
            <v-img
              :src="getIcon(item.icon)"
              lazy-src="data:image/png;base64,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"
              max-height="20"
              max-width="40"
              contain>
            </v-img>
          </template>
          <template v-slot:item.borders.poly_string="{ item }">
            <span class="d-inline-block text-truncate" style="max-width: 150px">
              {{item.borders.polyString}}
            </span>
          </template>
          <template v-slot:item.borders.stroke="{ item }">
            <v-sheet
              :width="24"
              :height="16"
              :elevation="1"
              :color="item.borders.stroke">
            </v-sheet>
          </template>
          <template v-slot:item.borders.fill="{ item }">
            <v-sheet
              :width="24"
              :height="16"
              :elevation="1"
              :color="item.borders.fill">
            </v-sheet>
          </template>
          <template v-slot:item.visible="{ item }">
            <v-icon :color="item.visible ? 'primary' : 'error'">{{ item.visible ? 'mdi-check' : 'mdi-close' }}</v-icon>
          </template>
          <template v-slot:item.icon.showLabel="{ item }">
            <v-icon :color="item.icon.showLabel ? 'primary' : 'error'">{{ item.icon.showLabel ? 'mdi-check' : 'mdi-close' }}</v-icon>
          </template>
          <template v-slot:item.website.show="{ item }">
            <v-icon :color="item.website.show ? 'primary' : 'error'">{{ item.website.show ? 'mdi-check' : 'mdi-close' }}</v-icon>
          </template>
          <template v-slot:item.website.url="{ item }">
            <span class="d-inline-block text-truncate" style="max-width: 150px">
              <a v-if="item.website.url" :href="item.website.url" target="_blank">{{ item.website.url }}</a>
            </span>
          </template>
          <template v-slot:item.actions="{ item }">
            <div style="white-space: nowrap">
              <v-icon
                small
                class="mr-2"
                @click="editItem(item)"
                color="accent"
                title="edit">
                mdi-pencil
              </v-icon>
              <v-icon
                small
                class="mr-2"
                @click="deleteItem(item)"
                color="error"
                title="delete">
                mdi-delete
              </v-icon>
              <v-icon
                small
                class="mr-2"
                @click="loadXLSX(item)"
                color="primary"
                title="import">
                mdi-file-excel
              </v-icon>
              <v-icon
                small
                @click="downloadXLSX(item)"
                color="primary"
                title="export">
                mdi-download
              </v-icon>
            </div>
          </template>
          <template v-slot:item.createdAt="{ item }">
            {{ (new Date(item.createdAt)).toLocaleString('ro-RO') }}
          </template>
          <template v-slot:item.updatedAt="{ item }">
            {{ (new Date(item.updatedAt)).toLocaleString('ro-RO') }}
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <v-btn
      color="primary"
      fab
      bottom
      right
      class="avz-fab"
      @click="openItemDialog">
      <v-icon>mdi-plus</v-icon>
    </v-btn>

    <v-dialog
      persistent
      scrollable
      v-model="itemForm"
      width="500">
      <v-card max-height="75vh">
        <v-card-title>
          <span>{{ aplAction === 'add' ? 'Adaugare' : 'Modificare' }} APL</span>
          <v-spacer></v-spacer>
          <v-btn icon small>
            <v-icon small color="error" @click="closeItemDialog">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form v-model="validForm" ref="form">
            <v-container>
              <v-row>
                <v-col>
                  <v-text-field
                    v-model="item.unique"
                    label="Cod unic de identificare"
                    hint="Cod unic de identificare in cadrul xlsx, folosit si pentru gestionarea resurselor de tip fisier"
                    required
                    :rules="required">
                  </v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <v-switch v-model="item.visible" label="APL vizibil?"></v-switch>
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <v-text-field
                    v-model="item.name"
                    label="Denumire APL"
                    hint="Denumire APL asa cum se va afisa ca parte a etichetei markerului"
                    required
                    :rules="required">
                  </v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <v-text-field
                    v-model="item.county"
                    label="Judet APL"
                    hint="Judetul de care apartione APL-ul, asa cum se va afisa ca parte a etichetei markerului"
                    required
                    :rules="required">
                  </v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <v-switch v-model="item.icon.showLabel" label="Eticheta vizibila (denumire, judet)?"></v-switch>
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <v-text-field
                    v-model="item.website.url"
                    label="Website APL"
                    hint="Adresa web a APL-ului"
                    required
                    :rules="required">
                  </v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <v-switch v-model="item.website.show" label="Logo cu link vizibil in header?"></v-switch>
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <p>Logo</p>
                  <v-img
                    :src="getIcon(item.logo, 'logo')"
                    lazy-src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADoAAAA8CAYAAAA34qk1AAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAABvpJREFUeJzNm3lsFFUcgGk5yiVdSkHlCEVAbkGDRyISjXIokSMEPEA5REQxIooma0NQrGIoBiVexPgHChiCIphQUMQoaGUhHI0BkUNAwilIodgWKMXvx77VYZk38+bt0PJLvjQtM+/9vp1371CjRhVGLLa+HtwCUfgKYvATLITnoTtkVmVOoQbJ14TblVQZXNBQDjsgHzpCWnXnbhwk2wCmwt8egm6chMXQq7odfIMk68BLUBpQ0skRmAmR6vbRBsn1heMpSCaohGXQtVqFonlv13X7u0ouVUmn7Ga4t6r9RLALzIKhLpKtfQYeW3bDoKoS7ABvw3Z4Axq4iEYDJH8W9sEmKIID6gnqrt8LA6+kYCZMg1NQCs/oriWR7w2a4jp4ArJc7m8CY2AplLjc/xd0vxKSHWEzXFCSYyDdQ/SAh6QkPglqmdTNdfXhVdjv0oxbhCWYDg/DSSV5Bib4SGZ4ND2ZT3vb5MJ9jWFGLD7HJspbLR+EvWGNi5IZ8CZUKMlK1XQ9nwQVt9FIloXRtyijB/ziKPe1mO0qCpnGMF8JJpgL9QwS6aoRnW2d0OV1yLp5FlSoD/CuwIUgkwWLkyQPQ2vDJDq4SB6TJx04Ge96ZA09IRZfIxdI0za+GZlGMC9JUprsuAAJRFxEZRTW9mvbkBYCD8FpGG10EzK1IS9JUtgCDQMmUJwk+paNSID6JsMauN73YmTGq1HVKSm/P2hRcaFDUvrRWCsD8/rSVTPu63khMs1gj8vT3CoLBYuK5zhEpVkNtrYIVq/33IzM+y6SQp5lhXc75lJpxv2tMg8zkGkLJS6S5XCrTZlqRNzvEO0Xdt6BA5mPNE/zT2nStuUi96Gj6VbNjkMXiNSHoxpRGW1r25aNXB/4B87BqDDyzcldnQERaArZkAn+OSIySiMprEklKbV6maee6is2ZSBRHzrDJFgCm2A77IZd8BtsgE9gKDSHy+drlxWQk59TEVWyveEUfBxQsBk8BxuhGM4acAb2QR5cOp+qzbNO9Neo5pgkgKgckL0LP5qsc0kwC6bAH4ZyOuQDausUPe0hegRapSKqZOWMdlXMZYPtEKwNg1WzTEXQyU5olRCt9BCVf3syBFFZjw6BmzWSXWABlCY1w8OqL4r8ISi3kF0Hdf2eqFAkW7YQZOUgu2eSYLoaQLbAXlgEuTAM7oBO0A7aQEforfrtcigJ0G8n+vVRQTbdr0PNEGT/mwZUUx0LM+FRJWV0UsB1jVUzLzKU3Syin/qICnIY9lQYso5kM9XTshrsuC9NPeUCA9EyEe0F5w1k5cxoCjQKSzaMQKK16oeesonDr5UGoonTv29gJGSbJMJ1adAUekYNjmEsZXvBMU9RlUyWWteayDr3qYWQDxNhBAyHR6Lxfe10WAI7oQC6OZOLrHiveciyi3xFlWx7C1k/1sMAt8QQvR9uCFF0hNdIfMnFJNVOffomfdaLmHqy2pUQku0hD+qEJCoD2w4jUSUrffYeWAonAshJa/gAjL7aQ7AhFEEoG3JkankMSmWeN5N0Heih+p/0OTkd/BIWReMnEpOhH1j1NyQLoBCutbJLCoS+1YiuD6N860BwDlyACWGUh9BqjWh+GOVbB4IvK9GNqY7COfEN+QbNEvDGsHK2CuTGwnkl+1gqZSHTVjMYpXR4EEogNwxKleiKVMpCaBCcSJKU3VDVvwqQHMgNgdNKVH5q96t+gdB0l6e5PMx8rQOx4VCmRIXHbcpRU8t3SZKyJOzmeSMV3gShfvOlqWeco48KC2zKUf3zkENSNugzTBLoA8sgx6Zi06D8aQ5JYUvQMtR2LTfpaa4C/6/81aplPnwNRruUoEG5abA4SbQ4aDk58ePNXQ7JbWD+7QKV9oQj8AO0DJqAQfnZsCdJVLjsVR5d5MSPYmY7JPfIli1oIjUhFyqlSUm/DWzjXf7opP6ZwHg5iNRtcFxJHoD+0pRtkrkOtqsEDsIAMHplxqfcFrDLRVJoalJGTvwoplBJiuyAHLcT+gBJ3QclKgn5OQv8v1XWlyf9f4lGUp6w7/coajp5QY2uB2FgSpIqsXQY75jvpCnvVnvJ9gHL6gQrNU32YqvxK0P1yxFqnpTdSg+r5qpJMANmQIUjqQrV/N6B/qA9NJMWAM/C7+qDcpMU1vpIylTSF7bCXBlxQxFMSvYa+ELzNIoj8U30Z2punAhPw1Q1TW2Fcg/BBLN9RGVhsBBGQqCXR4LKtoKlHk0vVe70Ec1Wslf+XXuSaQmfw7mQJbdFQhjRQ41IfLLPj/y/80gV6bcvVreXNkjuATgagqhMN1fvfw6QIMEmsCBy6YgcBDkcM3rH8KoIku0MK+CsoaAMaAsjIZ0AVnmQePNIfFpZq+nD8rdVMBBCfwlSF/8C3QjwwqUt65wAAAAASUVORK5CYII="
                    height="60"
                    position="center center"
                    contain
                    class="text-right">
                  </v-img>
                  <v-file-input
                    ref="file"
                    prepend-icon=""
                    v-model="item.logo.buffer"
                    label="Fisier grafic pentru logo"
                    persistent-hint
                    accept="image/*"
                    hint="Try to keep 'em optimized, pls">
                  </v-file-input>
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <p>Icon</p>
                  <v-item-group v-model="item.icon.url" mandatory>
                    <v-container>
                      <v-row>
                        <v-col
                          v-for="url in iconUrls"
                          :key="url"
                          cols="12"
                          md="4">
                          <v-item v-slot:default="{ active, toggle }" :value="url">
                            <v-img
                              :src="getIcon({ url })"
                              lazy-src="data:image/png;base64,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"
                              height="59"
                              position="center center"
                              contain
                              @click="toggle"
                              class="text-right">
                              <v-scroll-y-transition>
                                <v-icon v-if="active">mdi-map-marker-circle</v-icon>
                              </v-scroll-y-transition>
                            </v-img>
                          </v-item>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-item-group>
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <v-text-field
                    v-model.number="item.icon.scale"
                    type="number"
                    :max="1"
                    :min="0.1"
                    :step="0.01"
                    label="Icon scale"
                    hint="Kinda self explanatory, just play with it"
                    required
                    :rules="required">
                  </v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <v-text-field
                    v-model.number="item.center.lat"
                    label="Latitudine"
                    hint="Latitudine"
                    required
                    :rules="required">
                  </v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <v-text-field
                    v-model.number="item.center.lng"
                    label="Longitudine"
                    hint="Longitudine"
                    required
                    :rules="required">
                  </v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <GmapMap
                    :center="item.center"
                    :zoom="11"
                    map-type-id="roadmap"
                    style="width: 100%; height: 200px"
                    :options="{styles: mapStyles}">
                    <GmapMarker
                      draggable
                      @dragend="markerDragged"
                      :position="item.center"
                      :clickable="true"
                      :icon="{
                        url: getIcon(item.icon),
                        scaledSize: { width: 40 * item.icon.scale, height: 60 * item.icon.scale },
                        origin: { x: 0, y: 0 },
                        anchor: { x: (40 * item.icon.scale) / 2, y: 60 * item.icon.scale }
                      }"
                    />
                    <GmapPolygon :paths="decodePath(item)" :options="polyOptions(item)" :editable="false" />
                  </GmapMap>
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <v-textarea
                    v-model="item.borders.polyString"
                    label="Perimetru"
                    hint="Sir de caractere reprezentand permietrul codificat al APL-ului. Se obtine folosind aplicatia https://granite.dragos.club/"
                    required
                    :rules="required">
                  </v-textarea>
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <p>Culoare linie perimetru</p>
                  <v-color-picker
                    flat
                    v-model="item.borders.stroke"
                    show-swatches
                    canvas-height="100"
                    swatches-max-height="100px">
                  </v-color-picker>
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <p class="mt-4">Culoare umplere perimetru</p>
                  <v-color-picker
                    flat
                    v-model="item.borders.fill"
                    show-swatches
                    canvas-height="100"
                    swatches-max-height="100px">
                  </v-color-picker>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" outlined @click="closeItemDialog">Inchide</v-btn>
          <v-btn color="primary" @click="saveItem">Salveaza APL</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      persistent
      scrollable
      v-model="deleteItemDialog"
      width="500">
      <v-card>
        <v-card-title>Confirmati stergerea?</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          Daca stergeti un APL se vor pierde toate datele asociate!
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" outlined @click="cancelDelete">Anuleaza stergerea</v-btn>
          <v-btn color="primary" @click="confirmDelete">Sterge APL</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      persistent
      scrollable
      v-model="importDialog"
      width="500">
      <v-card max-height="75vh">
        <v-card-title>Import markere pentru {{ importApl.name }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-expansion-panels :value="0" class="mt-2" flat>
            <v-expansion-panel>
              <v-expansion-panel-header>Info</v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-alert type="info">
                  Apasati butonul pentru alegere fisier XLS(X) apoi configurati coloanele obligatorii. <br>
                  <v-list dense>
                    <v-list-item three-line>
                      <v-list-item-content>
                        <v-list-item-title>unique_apl</v-list-item-title>
                        <v-list-item-subtitle>codul unic ce desemneaza apl-ul de care apartine markerul</v-list-item-subtitle>
                        <v-list-item-subtitle>va fi folosit pentru a identifica resurse (fisiere)</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item three-line>
                      <v-list-item-content>
                        <v-list-item-title>unique</v-list-item-title>
                        <v-list-item-subtitle>codul unic ce identifica markerul</v-list-item-subtitle>
                        <v-list-item-subtitle>va fi folosit pentru a identifica resurse (fisiere)</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item three-line>
                      <v-list-item-content>
                        <v-list-item-title>status</v-list-item-title>
                        <v-list-item-subtitle>stadiu - se va corela cu Status Icons</v-list-item-subtitle>
                        <v-list-item-subtitle>marker icon &amp; modalitate de filtrare pusa la dispozitie utilizatorului</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item three-line>
                      <v-list-item-content>
                        <v-list-item-title>name</v-list-item-title>
                        <v-list-item-subtitle>denumire obiectiv</v-list-item-subtitle>
                        <v-list-item-subtitle>modalitate de filtrare pusa la dispozitie utilizatorului</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item three-line>
                      <v-list-item-content>
                        <v-list-item-title>categorie</v-list-item-title>
                        <v-list-item-subtitle>categorie - se va corela cu Categories</v-list-item-subtitle>
                        <v-list-item-subtitle>modalitate de filtrare pusa la dispozitie utilizatorului</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item two-line>
                      <v-list-item-content>
                        <v-list-item-title>availability</v-list-item-title>
                        <v-list-item-subtitle>disponibilitate: 1 - vizibil, 0 - ascuns, 2 - sters</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item two-line>
                      <v-list-item-content>
                        <v-list-item-title>address</v-list-item-title>
                        <v-list-item-subtitle>adresa marker</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item two-line>
                      <v-list-item-content>
                        <v-list-item-title>lat</v-list-item-title>
                        <v-list-item-subtitle>latitudine</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item two-line>
                      <v-list-item-content>
                        <v-list-item-title>lng</v-list-item-title>
                        <v-list-item-subtitle>longitudine</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-alert>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

          <v-form ref="fileForm">
            <v-file-input label="Fisier XLS(X)" ref="fileField" @change="fileAdded" :loading="fileLoading" persistent-hint hint="Celula marcata cu # semnaleaza randul ce contine capetele de tabel. Urmatoarele randuri se vor considera a fi date."></v-file-input>
            <template v-if="foundColumnHeaders.length">
              <p class="mt-2">Asociere coloane xls(x) cu proprietati obligatorii</p>
              <template v-for="(nul, col) in columnMatching">
                <v-select
                  :items="foundColumnHeaders"
                  item-text="cell"
                  item-value="index"
                  :label="col"
                  :key="col"
                  :rules="required"
                  v-model="columnMatching[col]">
                </v-select>
              </template>

              <v-btn color="accent" @click="parseMarkers">Import Markere</v-btn>
              <v-alert class="mt-2" :type="importedMarkers.length ? 'success' : 'error'">{{ importedMarkers.length }} markere valide</v-alert>
            </template>
          </v-form>
          <v-alert type="error" v-if="fileErrors.length">
            <ul>
              <li v-for="(e, i) in fileErrors" :key="i">{{ e }}</li>
            </ul>
          </v-alert>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" outlined @click="cancelImport">Anuleaza importarea</v-btn>
          <v-btn color="primary" @click="confirmImport">Importa datele</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      persistent
      scrollable
      v-model="exportMarkersDialog"
      width="75vw">
      <v-card max-height="75vh">
        <v-card-title>Alegeti coloanele pentru export {{ exportMarkers.length }} markere din {{ exportAPL }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-list flat>
            <v-list-item-group multiple v-model="selectedMarkerKeys">
              <v-list-item v-for="key in markerKeys" :key="key" :value="key">
                <template v-slot:default="{ active, toggle }">
                  <v-list-item-action>
                    <v-checkbox :input-value="active" @click="toggle"></v-checkbox>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>{{ key }}</v-list-item-title>
                  </v-list-item-content>
                </template>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" outlined @click="closeExportMarkers">Anuleaza export</v-btn>
          <v-btn color="primary" @click="confirmExportMarkers">Executa export</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import SERVER_URL from '@/config'
import mapStyles from '@/mapstyles/default.json'
import { gmapApi } from 'vue2-google-maps'
import _debounce from 'lodash.debounce'
import flatten from 'flat'
import tableHeaders from '@/mixins/tableHeaders'

import Worker from '@/workers/fileReader.worker.js'

export default {
  name: 'avz-apls',
  mixins: [tableHeaders],

  data: () => ({
    mapStyles,
    selectedHeaders: ['id', 'unic', 'vizibil', 'denumire', 'judet', 'eticheta', 'logo', 'icon', 'icon scale', 'web', 'web vizibil', 'lat', 'lng', 'permiteru', 'linie', 'umplere', 'creat', 'modificat', 'actions'],
    headers: [
      {
        text: 'id',
        value: '_id',
        align: 'start',
        sortable: false,
        filterable: false
      },
      {
        text: 'unic',
        value: 'unique',
        align: 'start',
        sortable: true,
        filterable: true
      },
      {
        text: 'vizibil',
        value: 'visible',
        align: 'center',
        sortable: true,
        filterable: true
      },
      {
        text: 'denumire',
        value: 'name',
        align: 'start',
        sortable: true,
        filterable: true
      },
      {
        text: 'judet',
        value: 'county',
        align: 'start',
        sortable: true,
        filterable: true
      },
      {
        text: 'eticheta',
        value: 'icon.showLabel',
        align: 'center',
        sortable: false,
        filterable: false
      },
      {
        text: 'logo',
        value: 'logo.url',
        align: 'center',
        sortable: false,
        filterable: false
      },
      {
        text: 'web',
        value: 'website.url',
        align: 'left',
        sortable: false,
        filterable: false
      },
      {
        text: 'web vizibil',
        value: 'website.show',
        align: 'left',
        sortable: false,
        filterable: false
      },
      {
        text: 'icon',
        value: 'icon.url',
        align: 'center',
        sortable: false,
        filterable: false
      },
      {
        text: 'icon scale',
        value: 'icon.scale',
        align: 'right',
        sortable: false,
        filterable: false
      },
      {
        text: 'lat',
        value: 'center.lat',
        align: 'end',
        sortable: false,
        filterable: false
      },
      {
        text: 'lng',
        value: 'center.lng',
        align: 'end',
        sortable: false,
        filterable: false
      },
      {
        text: 'permiteru',
        value: 'borders.poly_string',
        align: 'start',
        sortable: false,
        filterable: false
      },
      {
        text: 'linie',
        value: 'borders.stroke',
        align: 'center',
        sortable: false,
        filterable: false
      },
      {
        text: 'umplere',
        value: 'borders.fill',
        align: 'center',
        sortable: false,
        filterable: false
      },
      {
        text: 'creat',
        value: 'createdAt',
        align: 'start',
        sortable: true,
        filterable: true
      },
      {
        text: 'modificat',
        value: 'updatedAt',
        align: 'start',
        sortable: true,
        filterable: true
      },
      {
        text: 'actions',
        value: 'actions',
        sortable: false,
        filterable: false
      }
    ],
    itemForm: false,
    aplAction: 'add',
    validForm: true,
    required: [val => (val !== null && val !== undefined) || 'Campul nu poate fi gol!'],
    iconUrls: [
      '/icons/apl-icon-rosu.png',
      '/icons/apl-icon-verde.png',
      '/icons/apl-icon-albastru.png'
    ],
    item: {
      _id: null,
      unique: null,
      name: null,
      county: null,
      icon: {
        url: '/icons/apl-icon-verde.png',
        scale: 0.5,
        showLabel: true
      },
      logo: {
        buffer: null,
        url: null
      },
      website: {
        url: null,
        show: false
      },
      center: {
        lat: 44.4880501,
        lng: 26.0122288
      },
      borders: {
        polyString: null,
        stroke: '#ff0000',
        fill: '#ff9999'
      },
      visible: false
    },
    deleteItemDialog: false,
    deleteItemID: null,
    foundColumnHeaders: [],
    columnMatching: {
      unique_apl: null,
      unique: null,
      status: null,
      category: null,
      availability: null,
      address: null,
      name: null,
      lat: null,
      lng: null
    },
    importDialog: false,
    importApl: {
      name: null,
      _id: null
    },
    fileLoading: false,
    fileErrors: [],
    fileData: [],
    importedMarkers: [],

    exportMarkersDialog: false,
    selectedMarkerKeys: ['apl_id.name', 'unique_apl', 'unique', 'status', 'category', 'availability', 'address', 'name', 'lat', 'lng'],
    markerKeys: [],
    exportMarkers: [],
    exportAPL: null
  }),

  computed: {
    google: gmapApi,
    items () {
      return this.$store.getters.aplItems
    },
    totalItems () {
      return this.$store.getters.aplsTotal
    },
    loading () {
      return this.$store.getters.aplsLoading
    },
    decodePath () {
      return apl => {
        if (this.google && apl.borders.polyString) {
          const poly = this.google.maps.geometry.encoding.decodePath(apl.borders.polyString)

          return poly
        } else {
          return []
        }
      }
    },
    polyOptions () {
      return apl => ({
        fillColor: apl.borders.fill,
        strokeColor: apl.borders.stroke,
        // fillOpacity
        // strokeOpacity
        // strokeWeight
      })
    },
    options: {
      get () {
        return this.$store.getters.aplsOptions
      },
      set (value) {
        this.$store.dispatch('setAPLsOptions', value)
      }
    },
    search: {
      get () {
        return this.$store.getters.aplsSearch
      },
      set: _debounce(function (value) {
        this.$store.dispatch('setAPLsSearch', value)
      }, 500)
    },
    tableHeaders () {
      return this.headers.filter(head => this.selectedHeaders.includes(head.text))
    }
  },

  methods: {
    resetForm () {
      this.$refs.form.resetValidation()
      this.item = Object.assign(this.item, {}, JSON.parse(JSON.stringify(defaultItem)))
      this.aplAction = 'add'
    },
    closeItemDialog () {
      this.itemForm = false
      this.item = Object.assign(this.item, {}, JSON.parse(JSON.stringify(defaultItem)))
      this.resetForm()
    },
    openItemDialog () {
      this.itemForm = true
      this.aplAction = 'add'
    },
    saveItem () {
      this.$refs.form.validate()
      if (this.validForm) {
        const payload = Object.assign({}, this.item)
        this.$store.dispatch('saveAPL', payload)
        this.closeItemDialog()
      }
    },
    editItem (item) {
      this.item = Object.assign(this.item, {}, JSON.parse(JSON.stringify(item)))
      this.aplAction = 'edit'
      this.itemForm = true
    },
    deleteItem (item) {
      this.deleteItemID = item._id
      this.deleteItemDialog = true
    },
    confirmDelete () {
      const payload = this.deleteItemID
      this.$store.dispatch('deleteAPL', payload)
      this.deleteItemID = null
      this.deleteItemDialog = false
    },
    cancelDelete () {
      this.deleteItemID = null
      this.deleteItemDialog = false
    },
    getIcon (icon, type = 'icon') {
      const noFile = type === 'logo' ? '/logos/logo-tud-mic.png' : '/icons/apl-icon-orphan.png'
      return SERVER_URL + (icon && icon.url ? icon.url : noFile)
    },
    markerDragged ($event) {
      this.item.center = { lat: $event.latLng.lat(), lng: $event.latLng.lng() }
    },

    loadXLSX (apl) {
      this.importDialog = true
      this.importApl._id = apl._id
      this.importApl.name = apl.name
    },

    cancelImport () {
      this.importDialog = false
      this.importApl._id = null
      this.importApl.name = null
      this.fileErrors = Object.freeze([])
      this.fileData = Object.freeze([])
      this.foundColumnHeaders = Object.freeze([])
      this.importedMarkers = Object.freeze([])
      this.$refs.fileField.$refs.input.value = null
      this.$refs.fileForm.reset()
    },
    parseMarkers () {
      const valid = this.$refs.fileForm.validate()

      if (valid) {
        const items = this.fileData.map((row, index) => {
          const marker = { import: true, apl_id: this.importApl._id }
          Object.keys(this.columnMatching).forEach(col => {
            marker[col] = row[this.columnMatching[col]]
            if ((marker[col] === undefined || marker[col] === null)) {
              marker.import = false
              this.fileErrors = Object.freeze([`Markerul de pe randul ${index + 1} are ${col} nedefinit...`, ...this.fileErrors])
            }
          })

          return marker
        }).filter(marker => marker.import)

        this.importedMarkers = Object.freeze(items)
      }
    },
    confirmImport () {
      if (this.importedMarkers.length) {
        // perform save
        this.$store.dispatch('importMarkers', this.importedMarkers)

        this.importDialog = false
        this.importApl._id = null
        this.importApl.name = null
        this.fileErrors = Object.freeze([])
        this.fileData = Object.freeze([])
        this.foundColumnHeaders = Object.freeze([])
        this.importedMarkers = Object.freeze([])
        this.$refs.fileField.$refs.input.value = null
        this.$refs.fileForm.reset()
      }
    },
    async fileAdded ($event) {
      if ($event) {
        try {
          this.fileErrors = []
          this.foundColumnHeaders = []
          this.fileLoading = true
          const json = await readFile($event)
          this.fileLoading = false

          const headerRowIndex = json.findIndex(row => row.some(col => String(col).trim() === '#'))
          if (headerRowIndex !== -1) {
            this.foundColumnHeaders = json[headerRowIndex].map((cell, index) => ({ cell, index })).filter(cell => cell.cell)
            this.fileData = Object.freeze(json.slice(headerRowIndex + 1))
          } else {
            this.fileErrors = Object.freeze(['Nu am gasit simbolul # care semnaleaza inceputul randului ce contine capetele tabelului.', ...this.fileErrors])
          }
        } catch (err) {
          this.$refs.fileForm.reset()
          console.log(err)
        }
      }
    },
    refresh () {
      this.$store.dispatch('fetchAPLs')
    },

    async downloadXLSX (item) {
      try {
        const markers = await this.$store.dispatch('fetchAllMarkers', { apl_id: item._id })

        if (markers.length) {
          this.markerKeys = Object.keys(flatten(markers[0]))
          this.selectedMarkerKeys = ['apl_id.name', 'unique_apl', 'unique', 'status', 'category', 'availability', 'address', 'lat', 'lng']
          this.exportMarkers = Object.freeze(markers)
          this.exportAPL = item.name
          this.exportMarkersDialog = true
        }
      } catch (err) {
        console.log(err)
      }
    },
    closeExportMarkers () {
      this.exportMarkersDialog = false
      this.markerKeys = []
      this.exportMarkers = []
      this.exportAPL = null
    },
    confirmExportMarkers () {
      let table = `<thead><tr><th colspan="${this.selectedMarkerKeys.length}">Export ${this.exportAPL}<th></tr><tr><th></th></tr><tr>`

      this.selectedMarkerKeys.forEach(label => {
        table += `<th>${label}</th>`
      })
      table += '</tr></thead>'

      table += '<tbody>'
      this.exportMarkers.forEach((row, index) => {
        const flatRow = flatten(row)
        table += '<tr>'
        this.selectedMarkerKeys.forEach(key => {
          table += `<td>${flatRow[key] || ''}</td>`
        })
        table += '</tr>'
      })
      table += '</tbody>'

      const uri = 'data:application/vnd.ms-excel;base64,'
      const template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table><tr><td>{table}</td></tr></table></body></html>'
      const base64 = function (s) {
        return window.btoa(unescape(encodeURIComponent(s)))
      }
      const format = function (s, c) {
        return s.replace(/{(\w+)}/g, function (m, p) {
          return c[p]
        })
      }
      const ctx = {
        worksheet: `Reabilitare export ${this.exportAPL} ${(new Date()).toLocaleString('ro-RO').replace(/,/g, ' ').replace(/:/g, '.')}`,
        table
      }
      const link = document.createElement('a')
      link.download = `Reabilitare export ${this.exportAPL} ${(new Date()).toLocaleString('ro-RO').replace(/,/g, ' ').replace(/:/g, '.')}.xlsx`
      link.href = uri + base64(format(template, ctx))
      link.click()

      this.closeExportMarkers()
    }
  },

  mounted () {
    this.$store.dispatch('fetchAPLs')
  }
}

const defaultItem = {
  _id: null,
  unique: null,
  name: null,
  county: null,
  icon: {
    url: '/icons/apl-icon-verde.png',
    scale: 0.5,
    showLabel: true
  },
  logo: {
    buffer: null,
    url: null
  },
  website: {
    url: null,
    show: false
  },
  center: {
    lat: 44.4880501,
    lng: 26.0122288
  },
  borders: {
    polyString: null,
    stroke: '#ff0000',
    fill: '#ff9999'
  },
  visible: false
}

function readFile (file) {
  return new Promise((resolve, reject) => {
    const worker = new Worker()
    worker.onmessage = e => {
      worker.terminate()
      resolve(e.data.result)
    }

    worker.postMessage({ message: 'readFile', file })
  })
}

</script>
